import { render, staticRenderFns } from "./form-short-name.vue?vue&type=template&id=33dffe18&scoped=true&"
import script from "./form-short-name.vue?vue&type=script&lang=js&"
export * from "./form-short-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dffe18",
  null
  
)

export default component.exports